export default __webpack_public_path__ + "static/Resolve-Light-676f1e001bcbeabab80858c9eb536004.woff2";